import { CloseRounded } from "@mui/icons-material";
import { Box, Divider, IconButton, Stack } from "@mui/material";
import { useDrawer } from "src/components";

interface Props {
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  children: React.ReactNode;
}

const DrawerLayout = (props: Props) => {
  const { closeDrawer } = useDrawer();

  return (
    <>
      <Box
        sx={{
          backgroundColor: "#fff",
          position: "sticky",
          top: 0,
          zIndex: 3,
        }}
      >
        <Stack
          direction="row"
          spacing={0.25}
          sx={{
            alignItems: "center",
            justifyContent: "space-between",
            px: { xs: 0.5, sm: 1 },
            py: 0.5,
          }}
        >
          <Box sx={{ width: "100%" }}>{props.title}</Box>
          <IconButton size="small" onClick={closeDrawer}>
            <CloseRounded />
          </IconButton>
        </Stack>
        <Divider />
        {props.subtitle && (
          <>
            <Stack
              sx={{
                px: { xs: 0.5, sm: 1 },
                py: 0.5,
              }}
            >
              {props.subtitle}
            </Stack>
            <Divider />
          </>
        )}
      </Box>
      {props.children}
    </>
  );
};

export { DrawerLayout };
